<template>
  <div>
    <collapse :active-index="collapsed ? -1 : 0">
      <collapse-item>
        <h3 slot="title" class="mb-0">Productores Asignados</h3>
        <div>
          <ul class="list-group list-group-flush list my--3">
            <li v-for="producer in producers" :key="producer.id" class="list-group-item px-0">
              <div class="row align-items-center">
                <div class="col">
                  <h4 class="mb-0">
                    <router-link
                      v-if="$can('show', 'producers')"
                      :to="{ name: 'ProducerShow', params: { id: producer.id } }"
                    >
                      {{ producer.businessName }}
                    </router-link>
                    <p v-else>{{ producer.businessName }}</p>
                  </h4>
                  <!-- <span :class="`text-${producer.statusType}`">● </span>-->
                  <div class="small mt-1"><label>CUIT:&nbsp;</label>{{ producer.cuit }}</div>
                  <div class="small"><label>Email:&nbsp;</label>{{ producer.email }}</div>
                  <div v-if="producer.city" class="small">
                    <label>Localidad:&nbsp;</label>{{ producer.city.name }}, {{ producer.city.province.name }}
                  </div>
                  <div class="small"><label>Teléfono:&nbsp;</label>{{ producer.phone }}</div>
                </div>
                <div class="col">
                  <div class="text-center">
                    <div>Fecha Ult. Visita</div>
                    <small v-if="producer.lastVisit">
                      {{ producer.lastVisit.visitDate | date }}
                    </small>
                    <small v-else> - </small>
                  </div>
                </div>
                <div class="col text-center">
                  <div>
                    <badge type="danger">
                      <span class="mr-1">{{ producer.visitsCount }}</span>
                      <span v-if="producer.visitsCount === 1">Visita</span>
                      <span v-else>Visitas</span>
                    </badge>
                  </div>
                  <div>
                    <badge type="success">
                      <span class="mr-1">{{ producer.plotsCount }}</span>
                      <span v-if="producer.plotsCount === 1">Lote</span>
                      <span v-else>Lotes</span>
                    </badge>
                  </div>
                  <div>
                    <badge type="primary">
                      <span class="mr-1">{{ producer.documentsCount }}</span>
                      <span v-if="producer.documentsCount === 1">Archivo</span>
                      <span v-else>Archivos</span>
                    </badge>
                  </div>
                </div>
                <div class="col">
                  <div>
                    <badge type="primary">
                      <span v-if="producer.corn" class="mr-1">{{ producer.corn }}</span>
                      <span v-else class="mr-1">0</span>
                      <span>Has. Maíz</span>
                    </badge>
                  </div>
                  <div>
                    <badge type="default">
                      <span v-if="producer.storageCorn" class="mr-1">{{ producer.storageCorn }}</span>
                      <span v-else class="mr-1">0</span>
                      <span>Has. Maíz Silero</span>
                    </badge>
                  </div>
                  <div>
                    <badge type="info">
                      <span v-if="producer.alfalfa" class="mr-1">{{ producer.alfalfa }}</span>
                      <span v-else class="mr-1">0</span>
                      <span>Has. Alfalfa</span>
                    </badge>
                  </div>
                </div>
                <div class="col-auto">
                  <router-link
                    v-if="$can('show', 'producers')"
                    :to="{ name: 'ProducerShow', params: { id: producer.id } }"
                    class="btn base-button btn-outline-info btn-sm"
                  >
                    <i class="fas fa-eye"></i> VER DETALLES
                  </router-link>
                </div>
              </div>
            </li>
            <li v-if="producers.length === 0" class="list-group-item px-0">
              <div class="row align-items-center">
                <div class="col">
                  <h4 class="mb-0">No tiene productores asignados.</h4>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </collapse-item>
    </collapse>
  </div>
</template>

<script>
import Collapse from '@/components/Collapse/Collapse';
import CollapseItem from '@/components/Collapse/CollapseItem';

export default {
  name: 'ProducersList',
  components: {
    Collapse,
    CollapseItem,
  },

  props: {
    distributor: null,
    collapsed: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      producers: [],
    };
  },

  created() {
    const parameters = {
      append: 'lastvisit',
      sort: 'business_name',
      include: ['city.province', 'visitsCount', 'plotsCount', 'documentsCount'],
      'filter[distributor]': this.distributor,
    };

    this.$services
      .resource('producers')
      .get(parameters)
      .then((res) => res.data.data)
      .then((data) => (this.producers = data.producers));
  },
};
</script>
